import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import AnimateInView from '@/components/ui/animate-in-view';

/**
 * @component AboutSection
 * @description About section for the home page with company overview and imagery
 * @returns {JSX.Element} About section with refined styling and animations
 */
const AboutSection = () => {
  return <section aria-labelledby="about-heading" className="py-12 md:py-16 bg-dark-bg text-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 items-center">
          <AnimateInView animation="slide-left" className="space-y-5">
            <div className="inline-block">
              <div className="gold-divider"></div>
            </div>
            <h2 id="about-heading" className="text-3xl md:text-4xl tracking-tight text-gold">
              Who We Are
            </h2>
            <p className="text-lg text-white/90 max-w-prose">
              Forti-Fi is the leader in advanced perimeter security, blending cutting-edge technology with patented solutions to protect high-value properties, industrial sites, and private estates across Ontario.
            </p>
            <h3 className="text-xl font-medium text-gold">How We Do It</h3>
            <p className="text-white/80 max-w-prose">
              By embedding smart sensors and AI-driven analytics, our systems <strong>filter out false alerts</strong> and deliver actionable insights, not just noise. Whether securing farms or high-profile estates, these systems provide maintenance-free durability, and a seamless integration with existing infrastructure. Whether securing farms, estates, commercial real-estate, or industrial sites, our low-maintenance, always-on technology ensures the strongest defense for what matters most, 24/7.
            </p>
            <div className="pt-4">
              <Button asChild variant="gold" size="lg" className="text-white hover:text-dark-bg">
                <Link to="/about">Learn Our Approach</Link>
              </Button>
            </div>
          </AnimateInView>
          
          <AnimateInView animation="slide-right" delay={300} className="overflow-hidden rounded-lg shadow-premium hover:shadow-luxury-gold transition-all duration-500">
            <div className="rounded-lg overflow-hidden border border-gold/10">
              <img alt="Forti-Fi security installation" className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" loading="lazy" src="/images/expanse-farm.jpg" />
            </div>
          </AnimateInView>
        </div>
      </div>
    </section>;
};
export default AboutSection;